import React, { Component } from 'react';


class TermsCondition extends Component {
    state = {
        isActive: false,
        windowHeight: window.innerHeight - 60,
    };





    // the display
    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            this.setState({ isActive: false, });
            const formdisplay = document.querySelector(".dash_add_course_cover.termscondition")
            formdisplay.style.display = "none"
            const map = document.querySelector("div.maplocation")
            map.style.display = "inline-block"
        }

    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        this.setState({ windowHeight: window.innerHeight - 60 });
    };


    render() {

        const { menuCoverWidth } = this.state;


        console.log(this.state)
        return (

            <div className="dash_add_course_cover termscondition" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Terms & Condition </h2>
                    <p>Welcome to Geoinfotech Academy. Your privacy is important to us, and we are committed to protecting your personal information.
                        This Privacy Policy explains how we collect, use, and share information when you use our platform.<br />
                        1. Information We Collect<br />
                        We collect the following types of information:<br />
                        a. Personal Information<br />
                        When you register on our platform, enroll in a course, or make a payment, we may collect:<br />
                        <li>Full Name</li>
                        <li>Email Address</li>
                        <li>Phone Number</li>
                        <li>Payment Details (processed securely via a third-party payment provider)</li>
                        b. Usage Data<br />
                        We collect data about how you interact with our platform, including:<br />
                        <li>Course progress and completion</li>
                        <li>Pages visited and features used</li>
                        <li>Device information (IP address, browser type, etc.)</li>
                        c. Cookies and Tracking Technologies<br />
                        We use cookies and similar technologies to enhance your user experience,
                        analyze trends, and administer the platform. You can control cookie settings
                        in your browser.<br />
                        2. How We Use Your Information<br />
                        We use the information collected for the following purposes:<br />
                        <li>To provide and improve our educational services</li>
                        <li>To process payments and manage subscriptions</li>
                        <li>To personalize user experience and recommend courses</li>
                        <li>To ensure security and prevent fraud</li>
                        <li>To communicate with you regarding updates, promotions, and support</li>
                        3. How We Share Your Information<br />
                        We do not sell or rent your personal information. However, we may share it with:<br />
                        Service Providers: Third-party providers who help us process payments, host data, and deliver services.<br />
                        Legal Compliance: If required by law, we may disclose information to comply with legal obligations.<br />
                        4. Data Security<br />
                        We implement strict security measures to protect your personal data. However,
                        no system is completely secure, and we cannot guarantee absolute security.<br />
                        5. Your Rights and Choices<br />
                        You have the right to:<br />
                        Access, update, or delete your personal data<br />
                        6. Third-Party Links<br />
                        Our platform may contain links to third-party websites. We are not responsible for their privacy practices,
                        so please review their policies separately.<br />
                        7. Changes to This Policy<br />
                        We may update this Privacy Policy from time to time. Changes will be posted on this page
                        , and significant updates will be communicated via email or platform notifications.<br />
                        8. Contact Us<br/>
                        If you have any questions about this Privacy Policy, please contact us at:<br/>
                    </p>
                </div>
            </div>


        );
    }
}

export default TermsCondition;